import { Component, OnInit, ViewChild } from '@angular/core';
import {  ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import * as moment from 'moment';

@Component({
  selector: 'app-survey-startup-models',
  templateUrl: './survey-startup-models.component.html',
  styleUrls: ['./survey-startup-models.component.css'],
  providers: [ MessageService,ConfirmationService]
})

export class SurveyStartupModelsComponent implements OnInit {

  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Update model'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/surveys/survey-startup-models-edit/update',data.data.id]);
      }   
    },
  
 
 
    
    { field: 'name',headerName: 'Name',width:300 },
    
    { field: 'lang',headerName: 'Language' },
    { field: 'questions_count',headerName: 'Questions' },
    { field: 'date_creation',headerName: 'Creation date',
    valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
    { field: 'date_lastmodify',headerName: 'Last modify',
    valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          if(params.data.used_in)
            return '';
     
          return '<a title="'+'Delete model'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 
        if(params.data.used_in)
          return;

          _this.confirmationService.confirm({
            message: 'Attention: do you confirm the delete of the model?',
            accept: () => {
              _this.apiService.deleteStartupSurveyModel({id:params.data.id}).subscribe(data => {
                _this.addSingle('success', 'Success', 'Survey deleted');
                _this.load();
              });
            }
          });
     },
    }
  ];

  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  surveysmodelslist: any[] = [];
  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

  showArchived:boolean=false;

  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    public confirmationService: ConfirmationService,
  ) { }

  
  ngOnInit(): void {
    _this=this;
    this.load();
   
  }

  load(){
    
    const params: any = {'archived' : this.showArchived};
    this.apiService.get('surveys-startup-models/listall',params).subscribe(data => {
      this.surveysmodelslist=data.Result;
      this.gridApi.redrawRows();
    });
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  
  changeArchived(){
    this.load();

  }

}
var _this;